import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        navLink: {
            cursor: 'pointer',
            fontSize: '14px',
            textDecoration: 'none',
            opacity: 1,
            '&:hover': {
                color: theme.palette.primary.main,
                opacity: 1
            },
            '&:last-child': {
                marginRight: theme.spacing(1)
            }
        },
        disabled: {
            opacity: 0.5,
            cursor: 'default'
        },
        ltpStack: {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'start',
            justifySelf: 'start',
            marginRight: theme.spacing(1)
        },
        actionsContainer: {
            zIndex: 9
        }
    }
})